class __fragmenterClassesWorker{

     findAndRemove(className){
        const elems = document.querySelectorAll('.' + className);
             elems.forEach(element => {
                 element.classList.remove(className);
             });

       }

    add(elem, className){
         elem.classList.add(className);
    }
    remove(elem, className){
        elem.classList.remove(className);
    }

}

class __fragmenterSelectorWorker{

    selected_element;
    mode;
    constructor(selector, mode = 'single') {

        this.mode = mode;

        if (typeof selector === 'object'){
            this.selected_element = selector;
        }else if (selector === 'body'){
            this.selected_element = document.body;
        }else if (mode === 'single'){
           if(selector[0] === '#'){
               this.selected_element = document.getElementById(selector.slice(1));
           }
           if(selector[0] === '.'){
               this.selected_element = document.querySelector(selector);
           }
       }else if(mode === 'all'){
           if(selector[0] === '.'){
               this.selected_element = document.querySelectorAll(selector);
           }
       }



    }

    elements(){
        return this.selected_element;
    }

    parent(){
        this.selected_element = this.selected_element.parentNode;
        return this;
    }
    child(){
        this.selected_element = this.selected_element.parentNode;
        return this;
    }
    getData(name){
        return this.selected_element.dataset[name];
    }

    echo(){
        console.log(this.selected_element);
    }

    addUniqueClass(classname){
        FC.findAndRemove(classname);
        FC.add(this.selected_element, classname);
    }

    hasClass(classname){
        return this.selected_element.classList.contains(classname);
    }
    hide(){
        this.selected_element.style.display = 'none';
    }

    show(mod = false){
         if(mod){
             this.selected_element.style.display = mod;
         }else{
             this.selected_element.style.display = 'block';
         }

    }


    onClick(callback){
        if (this.mode === 'single'){
            this.selected_element.addEventListener('click', callback);
        }else{
            this.selected_element.forEach(element => {
                element.addEventListener('click', callback);
            });
        }
    }


    addClass(classname){
        if (this.mode === 'single'){
            FC.add(this.selected_element, classname);
        }else{
            this.selected_element.forEach(element => {
                FC.add(element, classname);
            });
        }

    }

    toggleClass(classname){
        if (this.mode === 'single'){
            selected_element.classList.toggle(classname);
        }else{
            this.selected_element.forEach(element => {
                element.classList.toggle(classname);
            });
        }

    }

    removeClass(classname){

        if (this.mode === 'single'){
            FC.remove(this.selected_element, classname);
        }else{
            this.selected_element.forEach(element => {
                FC.remove(element, classname);
            });
        }
    }

    getText(){
        return this.selected_element.innerText;
    }
    setText(text){
        this.selected_element.innerText = text;
    }
    getHtml(){
        return this.selected_element.innerHTML;
    }
    setHtml(text){
        this.selected_element.innerHTML = text;
    }

}








const FC = new __fragmenterClassesWorker();

function FS(selector, mode = 'single'){
    return new __fragmenterSelectorWorker(selector, mode);
}

document.addEventListener('DOMContentLoaded', function() {




        let blocks = document.querySelectorAll('section');


        function checkBlocksVisibility() {
            let windowHeight = window.innerHeight;

            blocks.forEach(function (block)  {
                let blockPosition = block.getBoundingClientRect().top;

                console.log(blockPosition)

                if (blockPosition < windowHeight - 100) {
                block.style.opacity = "1";
                //block.style.transform = "translateY(0)";
            }
        });
        }

        checkBlocksVisibility();

        window.addEventListener('scroll', function() {
            checkBlocksVisibility();
        });









FS('#burger-btn').onClick(function (){
    FS('body').addClass('burger__show');
});

FS('#burger-btn-close').onClick(function (){
    FS('body').removeClass('burger__show');
});

FS('.burger__nav .toggle', 'all').onClick(function (e){
    e.preventDefault();
    this.parentNode.parentNode.classList.toggle('sub-show');
});







window.onscroll = function() {myFunction()};


var header = document.getElementById("header");


var sticky = header.offsetTop;


function myFunction() {

    if (window.pageYOffset > sticky) {

     //   header.classList.add("header-fixed");
     //   document.body.classList.add("hfixed");
//
    } else {

      //  header.classList.remove("header-fixed");
      //  document.body.classList.remove("hfixed");
    }

}
[].forEach.call(document.querySelectorAll('input[type="tel"]'), function (input) {
    let keyCode;
    function mask(event) {
        this.parentNode.classList.add("form__group--active");
        event.keyCode && (keyCode = event.keyCode);
        let pos = this.selectionStart;
        if (pos < 3) event.preventDefault()
        let matrix = "+38 (___) ___-__-__",
            i = 0,
            def = matrix.replace(/\D/g, ""),
            val = this.value.replace(/\D/g, ""),
            newValue = matrix.replace(/[_\d]/g, function (a) {
                return i < val.length ? val.charAt(i++) || def.charAt(i) : a;
            });
        i = newValue.indexOf("_");
        if (i != -1) {
            i < 5 && (i = 3);
            newValue = newValue.slice(0, i);
        }
        let reg = matrix.substr(0, this.value.length).replace(/_+/g,
            function (a) {
                return "\\d{1," + a.length + "}";
            }).replace(/[+()]/g, "\\$&");
        reg = new RegExp("^" + reg + "$");
        if (!reg.test(this.value) || this.value.length < 5 || keyCode > 47 && keyCode < 58) this.value = newValue;
        if (event.type == "blur" && this.value.length < 5) this.value = "";
    }

    input.addEventListener("input", mask, false);
    input.addEventListener("focus", mask, false);
    input.addEventListener("blur", mask, false);
    input.addEventListener("keydown", mask, false);
    input.addEventListener('mouseup', event => {
        event.preventDefault()
        if (input.value.length < 4) {
            input.setSelectionRange(4, 4)
        } else {
            input.setSelectionRange(input.value.length, input.value.length)
        }
    })
});
FS('.seo__show').onClick(function (){
    FS('.seo').addClass('seo--show');
});
FS('.seo__hide').onClick(function (){
    FS('.seo').removeClass('seo--show');
});










});




function goToBlock(blockId){
    let animationTime = 600;
    let framesCount = 20;
    let coordY = document.querySelector(blockId).getBoundingClientRect().top + window.pageYOffset;
    coordY = coordY ;
    let scroller = setInterval(function() {
        let scrollBy = coordY / framesCount;
        if(scrollBy > window.pageYOffset - coordY && window.innerHeight + window.pageYOffset < document.body.offsetHeight) {
            window.scrollBy(0, scrollBy);
        } else {
            window.scrollTo(0, coordY);
            clearInterval(scroller);
        }
    }, animationTime / framesCount);
}